import { render, staticRenderFns } from "./StockScreen5.vue?vue&type=template&id=be6c6400"
import script from "./StockScreen5.vue?vue&type=script&lang=js"
export * from "./StockScreen5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports